import { useEffect, useState } from "react";
import "./EditItemModel.css";
import { getProjectEditdApi, updateProductAPI } from "./projectApi";
import { Spinner } from "react-bootstrap";

export default function EditItemModal({ id, onClose, onSave }) {
  const [productDetails, setProductDetails] = useState(null);
  const [amount, setAmount] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (id && id !== -1) {
      getProductDetails();
    }
  }, [id]); // ✅ important

  const getProductDetails = async () => {
    try {
      setLoading(true);
      const response = await getProjectEditdApi(id);

      if (response?.data?.success) {
        setProductDetails(response.data.product);
        setQuantity(response.data.product.qty);
        setAmount(response.data.product.amount);
      }
    } catch (err) {
      console.error("Error fetching product:", err);
    } finally {
      setLoading(false);
    }
  };
  const [errorMsg, setErrorMsg] = useState({
    product_id: "",
    qty: "",
    amount: "",
    ctc_amount: "",
  });
  const handleUpdate = async () => {
    try {
      setSaving(true);

      const payload = {
        product_id: id,
        qty: quantity,
        amount: amount,
        ctc_amount: amount,
      };

      const response = await updateProductAPI(id, payload);

      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            product_id: "",
            qty: "",
            amount: "",
            ctc_amount: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response?.data?.success) {
        onSave(response);
      }
    } catch (err) {
      console.error("Error updating product:", err);
    } finally {
      setSaving(false);
    }
  };
  // ❌ Do NOT open modal until data is loaded
  if (loading) return null;

  return (
    <div className="modal-backdrop">
      <div className="edit-modal">
        {/* Header */}
        <h2 className="modal-title">Edit</h2>

        {/* Product */}
        <div className="product-card">
          <span className="product-name">
            {productDetails?.product_label ?? "-"}
          </span>
        </div>
       <span className="error-txt fs-12 fw-500">{errorMsg.product_id}</span>
        {/* Inputs */}
        <div className="input-row">
          <div className="input-group">
            <label>Quantity</label>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              defaultValue={productDetails?.qty ?? ""}
              placeholder="Enter here..."
            />{" "}
            <span className="error-txt fs-12 fw-500">{errorMsg.qty}</span>
          </div>

          <div className="input-group">
            <label>Amount</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              defaultValue={productDetails?.amount ?? ""}
              placeholder="Enter here..."
            />{" "}
            <span className="error-txt fs-12 fw-500">{errorMsg.ctc_amount}</span>
          </div>
        </div>

        {/* Actions */}
        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-save" onClick={handleUpdate} disabled={saving}>
            {saving ? (
              <Spinner
                animation="border"
                size="sm"
                role="status"
                className="text-light"
              />
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
